import { makeStyles } from 'tss-react/mui'
import { BANNER_VARIANTS } from '../Sections.const'

const useStyles = makeStyles()((_theme, _params, classes) => ({
	root: {
		display: 'flex',
		alignItems: 'center',
	},
	[BANNER_VARIANTS.VARIANT_23]: {
		height: '100%',
		[`& .${classes.content}`]: {
			height: '100%',
		},
	},
	content: {},
}))

export default useStyles
